"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Gabe Kelley, Nick Howland, Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1746))
 * @lastsynced 2026-10-29T13:51:57.067Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const Heart = createSVGIcon(
  <path
    d="M12 21.343 2.539 12.69C-2.571 7.58 4.949-2.33 12 5.662c7.05-7.99 14.572 1.918 9.461 7.029z"
    strokeLinecap="round"
    strokeLinejoin="round"
    stroke="currentColor"
  />,
  "Heart",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      id: "KOuc/j",
      defaultMessage: "Save",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
    color: iconColor.primary,
    className: iconCls(),
  })
);
